import { configureStore, getDefaultMiddleware } from 'redux-starter-kit';
import reducers from 'reducers';
import { logout } from 'actions/auth';
import { loadState, saveState } from './storeCache';
import { presentError, shouldSilenceError } from './error_presenter';
import { toast } from 'react-toastify';

const errorHandlingMiddleware = store => next => action => {
  if (action.payload) {
    const { error } = action.payload;
    if (error && !shouldSilenceError(error)) {
      toast.error(presentError(error));
    }
    if (
      error &&
      (error === 'invalid_credentials' || error.includes('Unauthorized') || error.includes('Unauthenticated'))
    ) {
      return next(logout());
    }
  }
  return next(action);
};

const preloadedState = loadState();
let store = configureStore({
  reducer: reducers,
  middleware: [...getDefaultMiddleware(), errorHandlingMiddleware],
  devTools: process.env.NODE_ENV === 'development',
  preloadedState
});

store.subscribe(() => saveState(store.getState()));

export default store;
